import type { PrV2DiffStatsBreakdown, PrV2FileStats } from '@/lib/pr-v2/test-file-filter';

import { DiffLineStats } from '@/components/ui/diff-line-stats';

function BreakdownRow({ label, stats }: { label: string; stats: PrV2FileStats }) {
  return (
    <>
      <span className="pr-3 text-left">{label}</span>
      <span className="text-zinc-400">
        {`${stats.fileCount} ${stats.fileCount === 1 ? 'file' : 'files'}`}
      </span>
      {/* `contents` lets the + and - figures sit in their own grid columns. */}
      <DiffLineStats className="contents" additions={stats.additions} deletions={stats.deletions} />
    </>
  );
}

/**
 * A diff's line counts broken down into code, tests, and total, as the PR header and the inbox
 * rows show them on hover. Until the code / tests split is known, the total shows alone.
 */
export function DiffStatsBreakdown({
  stats,
}: {
  stats: PrV2DiffStatsBreakdown | Pick<PrV2DiffStatsBreakdown, 'total'>;
}) {
  return (
    <div
      className="grid grid-cols-[auto_auto_auto_auto] items-baseline gap-x-2 gap-y-1 text-right tabular-nums"
      data-testid="diff-stats-breakdown"
    >
      {'code' in stats ? (
        <>
          <BreakdownRow label="Code" stats={stats.code} />
          <BreakdownRow label="Tests" stats={stats.tests} />
          <div className="col-span-4 my-0.5 border-t" />
        </>
      ) : null}
      <BreakdownRow label="Total" stats={stats.total} />
    </div>
  );
}
